// --- React
import React from 'react';
// --- UI Components
import Modal from '@dtci/spellbook/Modal';
// --- Styles
import './styles.scss';

/**
 * DetailsModal Component
 *
 * This component is responsible for rendering a modal with a header, body, and footer.
 * It is used to display detailed information in a modal format.
 * The modal can be opened or closed based on the isOpen prop.
 * It accepts children elements to display content inside the modal body.
 *
 * @component
 * @param {boolean} isOpen - Indicates whether the modal is open or closed.
 * @param {function} onClose - Function to be called when the modal is closed.
 * @param {JSX.Element} children - The content to be displayed inside the modal.
 * @param {string} modalHeader - The header text for the modal.
 * @param {JSX.Element} footer - The footer content for the modal.
 * @returns {JSX.Element|null} The rendered DetailsModal component or null if not open.
 */
export function DetailsModal({ isOpen, onClose, children, modalHeader, footer }) {
    if (isOpen)
        return (
            <Modal
                bodyOverlay="blackout"
                headerText={modalHeader}
                modalId="DetailsModal"
                onClose={onClose}
                modalClass="DetailsModal"
                footer={footer}
            >
                {children}
            </Modal>
        );
    return null;
}
